import { useLocation, useNavigate } from "react-router-dom";
import { Map, Clock, HelpCircle, Info } from "lucide-react";

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: "/", icon: Map, label: "Map" },
    { path: "/timeline", icon: Clock, label: "Timeline" },
    { path: "/support", icon: HelpCircle, label: "Support" },
    { path: "/info", icon: Info, label: "Info" },
  ];

  return (
    <nav className="bottom-nav" role="navigation" aria-label="Main navigation">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;

        return (
          <button
            key={item.path}
            className={`nav-item touch-target ${isActive ? "active" : ""}`}
            onClick={() => navigate(item.path)}
            aria-label={item.label}
            aria-current={isActive ? "page" : undefined}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
